/**
 * Whether a segment's or a persona's blank name blocks a Lead Scoring save (PREC-4987).
 *
 * A save carries every segment and persona of the score, so the rule cannot be "any blank name
 * blocks": one blank Partner segment written before the editor refused blanks (score 163's
 * segment 1367) then blocked every unrelated edit, the Investors toggle and an HR title among
 * them. A blank name blocks only on a row the save creates, or on one the save renames to blank.
 * A row stored blank and still blank is left as it is: it is neither renamed nor deleted.
 *
 * The web asks this before it sends the save and the API asks it before it writes one, so the two
 * cannot disagree about which save is refused.
 *
 * @param stored the name the server holds; `undefined` for a row that does not exist yet
 * @param next the name the save carries; `undefined` when it does not carry one
 */
export function blankNameBlocksSave(
	stored: string | null | undefined,
	next: string | null | undefined
): boolean {
	const isNew = stored === undefined;

	if (!isNew && next === undefined) {
		return false;
	}

	if ((next ?? "").trim()) {
		return false;
	}

	return isNew || !!(stored ?? "").trim();
}
